import { Table, Row, Col } from "react-bootstrap";
import { ReviewContext } from "../ReviewPatient";
import { useCallback, useContext, useEffect, useState } from "react";
import { WEEKDAYS } from "../../util/const";
import { Bgl, Insulin } from "../../types/observation";
import { HourlyProps } from "../BglForm";
import React from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { FormatTimeForDisplay, FormatBglInfoDisplay, SetTimeslotForElement, Initialise } from "../../util/data-utils";
import DataNavigator from "../../Components/DataNavigator";
import { Patient } from "../../types/patient";


const BglBooklet = (props: HourlyProps) => {

  const context = useContext(ReviewContext);
  const patient = context.patient;

  const [bglMap, setBglMap] = useState<Map<string, Array<Bgl>>>();
  const [insulinMap, setInsulinMap] = useState<Map<string, Map<string,Array<Insulin>>>>();

  const BGL = "bgl";
  const INSULIN = "insulin";

  const amLower = parseFloat(patient.amLower);
  const amUpper = parseFloat(patient.amUpper);
  const fastingLower = parseFloat(patient.fastingLower);
  const fastingUpper = parseFloat(patient.fastingUpper);

  var today = new Date(context.weekEnding);
  var timeInMillis = today.getTime();
  var day = today.getDay() + 1; // day as weekday number
  var dayCounter = 0;

  const loadData = useCallback((aPatient: Patient) => {

    const dataMaps = () => {

      var bglMap: Map<string, Array<Bgl>> = new Map<string, Array<Bgl>>();
      var insulinMap: Map<string, Map<string,Array<Insulin>>> = new Map<string, Map<string,Array<Insulin>>>();
  
      if (aPatient.observations !== undefined && aPatient.observations.size > 0)
      {
        var bgls: Array<Bgl> | undefined;
        if (aPatient.observations.has(BGL))
          bgls = aPatient.observations.get(BGL) as Array<Bgl>;
        let hasBgls = bgls !== undefined && bgls.length > 0;
  
        var insulins: Array<Insulin> | undefined;
        if (aPatient.observations.has(INSULIN))
          insulins = aPatient.observations.get(INSULIN) as Array<Insulin>;
        let hasInsulins = insulins !== undefined && insulins.length > 0;
  
        if (hasBgls)
        {
          Initialise(aPatient);
          
          bgls?.forEach((element) => {
            SetTimeslotForElement(element, aPatient);
            let key = WEEKDAYS[element.weekDay];
            if(bglMap.has(key))
            {
              bglMap.get(key)!.push(element);
            }
            else
            {
              bglMap.set(key, [element])
            }
            // var aDayBgls: Array<Bgl>;
            // if (bglMap.has(key)) aDayBgls = bglMap.get(key)!;
            // else aDayBgls = new Array<Bgl>();
            // aDayBgls?.push(element);
            // bglMap.set(key, aDayBgls);
          });
        }
  
        if (hasInsulins)
        {
          insulins?.forEach((element) => {
            SetTimeslotForElement(element, aPatient);
            let key = WEEKDAYS[element.weekDay];
  
            if(insulinMap.has(key)){
              var aDayData = insulinMap.get(key)
              if(aDayData?.has(element.context)){
                aDayData.get(element.context)?.push(element)
              }
              else{
                aDayData?.set(element.context, [element])
              }
            }
            else{
              var temp: Map<string,Array<Insulin>> = new Map<string,Array<Insulin>>();
              temp.set(element.context, [element])
              insulinMap.set(key, temp)
            }
          });
        }
      }
      return [bglMap, insulinMap];
    };

    let [bglMap , insulinMap] = dataMaps();
    setBglMap(bglMap as Map<string, Array<Bgl>>);
    setInsulinMap(insulinMap as Map<string, Map<string,Array<Insulin>>>);
  },[]);

  useEffect(() => {
    loadData(context.patient);
  },[context, loadData]);

  return (
    <Table striped bordered hover className="review-table">
      <thead>
        <tr>
          <th colSpan={17}>
            <Row>
              <Col className="left">
                <DataNavigator typeKey="bgl" />
              </Col>
              <Col className="right me-2">
                {FormatBglInfoDisplay(patient)}
              </Col>
            </Row>
          </th>
        </tr>
        <tr>
          <th colSpan={6} className="section">
            <Row>
              <Col />
              <Col>Insulin Injections</Col>
              <Col />
            </Row>
          </th>
          <th colSpan={9} className="section">
            <Row>
              <Col />
              <Col>Monitoring Blood Glucose</Col>
              <Col />
            </Row>
          </th>
          <th rowSpan={3} className="last">
            Remarks
            <div className="light">
              Activity, illness,
              <br />
              diet changes
              <br /> time of hypos...
            </div>
          </th>
        </tr>
        <tr>
          <th rowSpan={2}></th>
          <th colSpan={5}>Insulin and Metformin</th>
          <th rowSpan={2}>Fasting</th>
          <th colSpan={2}>Breakfast</th>
          <th colSpan={2}>Lunch</th>
          <th colSpan={2}>Dinner</th>
          <th rowSpan={2}>
            Before
            <br />
            Supper
            <br />
            or Bed
          </th>
          <th rowSpan={2}>
            Over
            <br />
            Night
          </th>
        </tr>
        <tr className="light">
          <th>Morning</th>
          <th>Breakfast</th>
          <th>Lunch</th>
          <th>Dinner</th>
          <th>Bedtime</th>
          <th>Before</th>
          <th>After</th>
          <th>Before</th>
          <th>After</th>
          <th>Before</th>
          <th>After</th>
        </tr>
      </thead>
      <tbody>
        { WEEKDAYS.map(() => {
          day = day - 1;
          if (day < 0) {
            day = 7 + day;
          }
          var dayKey = WEEKDAYS[day];

          var nextDate = new Date(timeInMillis - dayCounter * 24 * 3600 * 1000);
          var dayOfMonthStr = nextDate.getDate().toString();
          if(dayOfMonthStr.length === 1)
            dayOfMonthStr = "0" + dayOfMonthStr;
          dayCounter++;

          /// bgls
          var bglList = bglMap?.get(dayKey);
          var fasting: any[] = [];
          var postBreakfast: any[] = [];
          var postLunch: any[] = [];
          var postDinner: any[] = [];
          var overnight: any[] = [];
          let notes = [];
          var fastingBgl: Bgl | undefined;
          var postBreakfastBgl: Bgl | undefined;
          var postLunchBgl: Bgl | undefined;
          var postDinnerBgl: Bgl | undefined;
          var overnightBgl: Bgl | undefined;

          // Find the latest bgl record
          bglList?.forEach((element) => {
            if (element.fasting !== undefined) {
              if (fastingBgl !== undefined) {
                if (element.recordedTime > fastingBgl.recordedTime) {
                  fastingBgl = element;
                }
              } else {
                fastingBgl = element;
              }
            }
            if (element.postBreakfast !== undefined) {
              if (postBreakfastBgl !== undefined) {
                if (element.recordedTime > postBreakfastBgl.recordedTime) {
                  postBreakfastBgl = element;
                }
              } else {
                postBreakfastBgl = element;
              }
            }
            if (element.postLunch !== undefined) {
              if (postLunchBgl !== undefined) {
                if (element.recordedTime > postLunchBgl.recordedTime) {
                  postLunchBgl = element;
                }
              } else {
                postLunchBgl = element;
              }
            }
            if (element.postDinner !== undefined) {
              if (postDinnerBgl !== undefined) {
                if (element.recordedTime > postDinnerBgl.recordedTime) {
                  postDinnerBgl = element;
                }
              } else {
                postDinnerBgl = element;
              }
            }
            if (element.overnight !== undefined) {
              if (overnightBgl !== undefined) {
                if (element.recordedTime > overnightBgl.recordedTime) {
                  overnightBgl = element;
                }
              } else {
                overnightBgl = element;
              }
            }
          });

          var fastingTime: string = "";
          var postBreakfastTime: string = "";
          var postLunchTime: string = "";
          var postDinnerTime: string = "";
          var overnightTime: string = "";

          // Color bgl number - fasting
          if (fastingBgl != null) {
            let fastingNumber: number = parseFloat(fastingBgl.fasting);
            if (fastingNumber < fastingLower) {
              fasting.push(<div className="low-bgl">{fastingBgl.fasting}</div>);
            } else if (fastingNumber > fastingUpper) {
              fasting.push(<div className="high-bgl">{fastingBgl.fasting}</div>);
            } else {
              fasting.push(<div>{fastingBgl.fasting}</div>);
            }
            fastingTime = FormatTimeForDisplay(fastingBgl.recordedTime);

            if(fastingBgl?.notes!== null){
              notes.push(<div>{fastingTime +" | " + fastingBgl.fasting + " | " + fastingBgl?.notes}<br /></div>);
            }
          }

          // Color bgl number - breakfast
          if (postBreakfastBgl !== undefined) {
            let postBreakfastNumber: number = parseFloat(postBreakfastBgl.postBreakfast);
            if (postBreakfastNumber < amLower) {
              postBreakfast.push(<div className="low-bgl">{postBreakfastBgl.postBreakfast}</div>);
            } else if (postBreakfastNumber > amUpper) {
              postBreakfast.push(<div className="high-bgl">{postBreakfastBgl.postBreakfast}</div>);
            } else {
              postBreakfast.push(<div>{postBreakfastBgl.postBreakfast}</div>);
            }
            postBreakfastTime = FormatTimeForDisplay(postBreakfastBgl.recordedTime);
            
            if(postBreakfastBgl?.notes!== null){
              notes.push(<div>{postBreakfastTime +" | " + postBreakfastBgl.postBreakfast + " | " + postBreakfastBgl?.notes}<br /></div>);
            }
          }

          // Color bgl number - lunch
          if (postLunchBgl != null) {
            let postLunchNumber: number = parseFloat(postLunchBgl.postLunch);
            if (postLunchNumber < amLower) {
              postLunch.push(<div className="low-bgl">{postLunchBgl.postLunch}</div>);
            } else if (postLunchNumber > amUpper) {
              postLunch.push(<div className="high-bgl">{postLunchBgl.postLunch}</div>);
            } else {
              postLunch.push(<div>{postLunchBgl.postLunch}</div>);
            }
            postLunchTime = FormatTimeForDisplay(postLunchBgl.recordedTime);

            if(postLunchBgl?.notes!== null){
              notes.push(<div>{postLunchTime +" | " + postLunchBgl.postLunch + " | " + postLunchBgl?.notes}<br /></div>);
            }
          }

          // Color bgl number - dinner
          if (postDinnerBgl != null) {
            let postDinnerNumber: number = parseFloat(postDinnerBgl.postDinner);
            if (postDinnerNumber < amLower) {
              postDinner.push(<div className="low-bgl">{postDinnerBgl.postDinner}</div>);
            } else if (postDinnerNumber > amUpper) {
              postDinner.push(<div className="high-bgl">{postDinnerBgl.postDinner}</div>);
            } else {
              postDinner.push(<div>{postDinnerBgl.postDinner}</div>);
            }
            postDinnerTime = FormatTimeForDisplay(postDinnerBgl.recordedTime);

            if(postDinnerBgl?.notes!== null){
              notes.push(<div>{postDinnerTime +" | " + postDinnerBgl.postDinner + " | " + postDinnerBgl?.notes}<br /></div>);
            }
          }

          // Color bgl number - overnight
          if (overnightBgl != null) {
            let overnightNumber: number = parseFloat(overnightBgl.overnight);
            if (overnightNumber < amLower) {
              overnight.push(<div className="low-bgl">{overnightBgl.overnight}</div>);
            } else if (overnightNumber > amUpper) {
              overnight.push(<div className="high-bgl">{overnightBgl.overnight}</div>);
            } else {
              overnight.push(<div>{overnightBgl.overnight}</div>);
            }
            overnightTime = FormatTimeForDisplay(overnightBgl.recordedTime);
            
            if(overnightBgl?.notes!== null){
              notes.push(<div>{overnightTime + " | " + overnightBgl.overnight + " | " + overnightBgl?.notes}<br /></div>)
            }
          }

          var fastingDose1: any[] = [];
          var postBreakfastDose1: any[] = [];
          var postLunchDose1: any[] =[];
          var postDinnerDose1: any[] = [];
          var bedtimeDose1: any[] = [];

          let insulinTypeMap = insulinMap?.get(dayKey);
          insulinTypeMap?.forEach((value, key) => {

            if(key === "Morning"){
              value.forEach((element ) =>{
                if(element.name !=="" && element.name != null){
                  fastingDose1.push(
                    <div>
                      {element.name}: {element.dose}units
                    </div>
                  )
                }
                if(element.metforminDose !== "" && element.metforminDose != null){
                  fastingDose1.push(
                    <div>
                      Metformin: {element.metforminDose}mg
                    </div>
                  )
                }
              })
            }

            if(key === "Before Breakfast"){
              value.forEach((element ) =>{
                if(element.name !=="" && element.name != null){
                  postBreakfastDose1.push(
                    <div>
                      {element.name}: {element.dose}units
                    </div>
                  )
                }
                if(element.metforminDose !== "" && element.metforminDose != null){
                  postBreakfastDose1.push(
                    <div>
                      Metformin: {element.metforminDose}mg
                    </div>
                  )
                }
              })
            }

            if(key === "Before Lunch"){
              value.forEach((element ) =>{
                if(element.name !=="" && element.name != null){
                  postLunchDose1.push(
                    <div>
                      {element.name}: {element.dose}units
                    </div>
                  )
                }
                if(element.metforminDose !== "" && element.metforminDose != null){
                  postLunchDose1.push(
                    <div>
                      Metformin: {element.metforminDose}mg
                    </div>
                  )
                }
              })
            }

            if(key === "Before Dinner"){
              value.forEach((element ) =>{
                if(element.name !=="" && element.name != null){
                  postDinnerDose1.push(
                    <div>
                      {element.name}: {element.dose}units
                    </div>
                  )
                }
                if(element.metforminDose !== "" && element.metforminDose != null){
                  postDinnerDose1.push(
                    <div>
                      Metformin: {element.metforminDose}mg
                    </div>
                  )
                }
              })
            }

            if(key === "Bedtime"){
              value.forEach((element ) =>{
                if(element.name !=="" && element.name != null){
                  bedtimeDose1.push(
                    <div>
                      {element.name}: {element.dose}units
                    </div>
                  )
                }
                if(element.metforminDose !== "" && element.metforminDose != null){
                  bedtimeDose1.push(
                    <div>
                      Metformin: {element.metforminDose}mg
                    </div>
                  )
                }
              })
            }
          });
          return (
            <React.Fragment key={dayKey}>
              <tr onClick={props.toggleHourly}>
                <td>{dayKey} {dayOfMonthStr}</td>
                <td className="small-font">{fastingDose1}</td>
                <td className="small-font">{postBreakfastDose1}</td>
                <td className="small-font">{postLunchDose1}</td>
                <td className="small-font">{postDinnerDose1}</td>
                <td className="small-font">{bedtimeDose1}</td>
                <td className="fasting">
                  <OverlayTrigger
                    placement="right"
                    delay={{ show: 250, hide: 400 }}
                    overlay={<Tooltip className="tooltip">{fastingBgl?.notes == null? fastingTime: fastingTime+" | "+fastingBgl?.notes}</Tooltip>}>
                    <span>{fasting}</span>
                  </OverlayTrigger>
                </td>
                <td className="breakfast"></td>
                <td className="breakfast">
                  <OverlayTrigger
                    placement="right"
                    delay={{ show: 250, hide: 400 }}                                          
                    overlay={<Tooltip className="tooltip">{postBreakfastBgl?.notes == null? postBreakfastTime: postBreakfastTime+" | "+postBreakfastBgl?.notes}</Tooltip>}>
                    <span>{postBreakfast}</span>
                  </OverlayTrigger>
                </td>
                <td className="lunch"></td>
                <td className="lunch">
                  <OverlayTrigger
                    placement="right"
                    delay={{ show: 250, hide: 400 }}                                          
                    overlay={<Tooltip className="tooltip">{postLunchBgl?.notes == null? postLunchTime: postLunchTime+" | "+postLunchBgl?.notes}</Tooltip>}>
                    <span>{postLunch}</span>
                  </OverlayTrigger>
                </td>
                <td className="dinner"></td>
                <td className="dinner">
                  <OverlayTrigger
                    placement="right"
                    delay={{ show: 250, hide: 400 }}
                    overlay={<Tooltip className="tooltip">{postDinnerBgl?.notes == null? postDinnerTime: postDinnerTime+" | "+postDinnerBgl?.notes}</Tooltip>}>
                    <span>{postDinner}</span>
                  </OverlayTrigger>
                </td>
                <td>
                  {/* <OverlayTrigger
                    placement="right"
                    delay={{ show: 250, hide: 400 }}
                    overlay={<Tooltip className="tooltip">{bedtimeBgl?.notes == null? bedTime: bedTime+" | "+bedtimeBgl?.notes}</Tooltip>}>
                    <span>{beforeBed}</span>
                  </OverlayTrigger> */}
                </td>
                <td>
                  <OverlayTrigger
                    placement="right"
                    delay={{ show: 250, hide: 400 }}
                    overlay={<Tooltip className="tooltip">{overnightBgl?.notes == null? overnightTime: overnightTime+" | "+overnightBgl?.notes}</Tooltip>}>
                    <span>{overnight}</span>
                  </OverlayTrigger>
                </td>
                <td className="left small-font"><div>{notes}</div></td>
              </tr>
            </React.Fragment>
          );
        })}
      </tbody>
    </Table>
  );
};

export default BglBooklet;
